import { render, staticRenderFns } from "./StateEffect.vue?vue&type=template&id=805d2058&scoped=true&"
import script from "./StateEffect.vue?vue&type=script&lang=js&"
export * from "./StateEffect.vue?vue&type=script&lang=js&"
import style0 from "./StateEffect.vue?vue&type=style&index=0&id=805d2058&scoped=true&lang=css&"
import style1 from "./StateEffect.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "805d2058",
  null
  
)

export default component.exports